<template>
  <div class="tk-search-input">
    <v-text-field
      v-model="searchText"
      class="search-input"
      ref="searchInput"
      color="#4a4a4a"
      append-icon="fas fa-search"
      hide-details
      clearable
      solo
      flat
      :label="$t('SEARCH.PLACEHOLDER')"
      @focus="onInputFocus"
      @click:append="onAppendClicked"
      @input="onSearchInput"
    />
  </div>
</template>


<script>
import debounce from "@/utils/TinyDebounce";
import { SearchFilters } from "@/services/search/SearchFilters";
import { ROUTE_QUERY } from "@/AppKeys";

export default {
  inject: [ROUTE_QUERY],

  data: () => ({
    searchText: null,
  }),

  mounted() {
    this.$emit("mounted");
  },

  watch: {
    "$route.query.keyword": {
      immediate: true,
      handler: function (val) {
        console.log("TK_SEARCH_INPUT", "OnRouteQueryChanged", val);
        this.searchText = val;
      },
    },
  },

  methods: {
    onSearchInput: debounce(function (e) {
      this.onSearchInputChanged(e);
    }),

    onInputFocus() {
      if (!this.$vuetify.breakpoint.smAndDown) {
        if (this.$route.name != "search") {
          this.$router.push({ name: "search" });
        }
      }
    },
    onAppendClicked() {
      if (this.$route.name != "search" && !this.$vuetify.breakpoint.smAndDown) {
        this.onSearchInputChanged(this.searchText);
      } else {
        this.$emit("click:append");
      }
    },

    onSearchInputChanged(val) {
      const routeQuery = this[ROUTE_QUERY];
      const filtersFromQuery = new SearchFilters().fromQuery(this.$route.query);
      // console.log({ filtersFromQuery });
      filtersFromQuery.searchText = val;
      filtersFromQuery.page = 1; // Reset the page
      routeQuery.push(filtersFromQuery.toQuery());
    },
  },
};
</script>


<style lang="scss" scopped>
$height: 40px;

.tk-search-input {
  // width: 410px;
  .search-input {
    &.theme--light.v-text-field--solo {
      .v-input__control {
        min-height: $height;
        .v-input__slot {
          border: 1px solid #000000;

          .v-label {
            font-size: 1rem;
          }
        }
        .v-input__append-inner {
          // padding-right: 8px;
          .v-icon {
            font-size: 1.2rem;
          }
        }
      }
    }
  }
}
</style>
